import {Routes} from '@angular/router';
import {LayoutComponent} from "./pages/secure/layout/layout.component";
import {ErmRegisterComponent} from "./pages/secure/erm-register/erm-register.component";
import {
  RightSearchByPersonalIdComponent
} from "./pages/secure/right-search/personal-id/right-search-by-personal-id.component";
import {RightSearchByNameComponent} from "./pages/secure/right-search/name/right-search-by-name.component";
import {
  RightSearchByNameDetailComponent
} from "./pages/secure/right-search/name/detail/right-search-by-name-detail.component";
import {RightSearchByIdCardComponent} from "./pages/secure/right-search/idcard/right-search-by-id-card.component";
import {RightSearchByThaidComponent} from "./pages/secure/right-search/thaid/right-search-by-thaid.component";
import {PortalComponent} from "./pages/secure/portal/portal.component";
import {AutoLoginPartialRoutesGuard} from "angular-auth-oidc-client";
import {P404Component} from "./shared/commons/interceptor/error/404.component";
import {P403Component} from "./shared/commons/interceptor/error/403.component";
import {LandingComponent} from "./pages/secure/landing/landing.component";
import {HistoryComponent} from "./pages/secure/history/history.component";
import {UcRegisterHistoryComponent} from "./pages/secure/history/uc-register-history/uc-register-history.component";
import {DigitalAddressComponent} from "./pages/secure/right-search/digital-address/digital-address.component";
import {
  ChangeHealthInsuranceComponent
} from "./pages/secure/report/change-health-insurance/change-health-insurance.component";
import {
  DeceasedEligibleServiceComponent
} from "./pages/secure/report/deceased-eligible-service/deceased-eligible-service.component";
import {PointContainerComponent} from "./pages/secure/point/point-container.component";
import {RegisterFormsComponent} from "./pages/secure/register/register-forms/register-forms.component";
import {SummaryComponent} from "./pages/secure/arbitrary/summary/summary.component";
import {InternalRightSearchComponent} from "./pages/secure/internal/internal-right-search.component";
import {RevokedComponent} from "./pages/secure/revoked/revoked.component";
import {CallbackComponent} from "./security/callback.component";
import {RightSearchComponent} from "./pages/secure/right-search/right-search.component";
import {UcepComponent} from "./pages/secure/ucep/ucep.component";
import {UcAdvanceComponent} from "./pages/secure/uc-advance/uc-advance.component";
import {UcAdvanceRegisterComponent} from "./pages/secure/uc-advance/uc-advance-register/uc-advance-register.component";
import {UcAdvanceHistoryComponent} from "./pages/secure/uc-advance/uc-advance-history/uc-advance-history.component";
import {ArbitraryMode, NewWorkComponent} from "./pages/secure/arbitrary/new-work/new-work.component";
import {ManageEmailComponent} from "./pages/secure/arbitrary/manage-email/manage-email.component";
import {CreatedBookComponent} from "./pages/secure/arbitrary/created-book/created-book.component";
import {RightHistoryComponent} from "./pages/secure/right-history/right-history.component";
import {roleGuard} from "./security/role.guard";
import {ArbitraryReportComponent} from "./pages/secure/arbitrary/report/arbitrary-report.component";
import {TasksDetailsResolverService} from "./pages/secure/arbitrary/tasks-details/tasks-details.resolver";
import {TasksDetailsComponent} from "./pages/secure/arbitrary/tasks-details/tasks-details.component";
import {PointSummaryReportComponent} from "./pages/secure/point/report/point-summary-report.component";
import {CurrentPointComponent} from "./pages/secure/point/current/current-point.component";
import {PointHistoryComponent} from "./pages/secure/point/history/point-history.component";
import {
  RightHistoryDetailComponent
} from "./pages/secure/right-history/right-history-detail/right-history-detail.component";
import {MapComponent} from "./pages/map/map.component";
import {ManageEmailPointComponent} from "./pages/secure/point/manage-email-point/manage-email-point.component";
import {ModifyRightComponent} from "./pages/secure/modify-right/modify-right.component";
import {RightSearchSssComponent} from "./pages/secure/right-search/sss/right-search-sss.component";
import {
  ermRegMainConsiderServiceResolver
} from "./pages/secure/right-history/right-history-detail/erm-reg-main-consider-service.resolver";
import {ExcludedHospitalsComponent} from "./pages/secure/point/excluded-hospitals/excluded-hospitals.component";
import {appGuard} from "./app.guard";
import {UnauthorizedComponent} from "./unauthorized/unauthorized.component";

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'secure'
  },
  {
    path: 'callback',
    component: CallbackComponent
  },
  // {
  //   path: 'home',
  //   component: HomeComponent,
  // canActivate: [authenGuard]
  // },
  {
    path: 'portal',
    component: PortalComponent,
  },
  {
    path: 'map',
    component: MapComponent,
  },
  {
    path: 'public',
    loadChildren: () => import('./pages/public/public.module').then(m => m.PublicModule)
  },
  {
    path: 'internal/rights/search',
    component: InternalRightSearchComponent,
    canActivate: [AutoLoginPartialRoutesGuard],
    data: {title: 'ตรวจสอบสิทธิ'},
  },
  {
    path: 'secure',
    component: LayoutComponent,
    canActivate: [AutoLoginPartialRoutesGuard, appGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'landing'
      },
      {
        path: 'landing',
        component: LandingComponent,
        data: {title: 'ประกาศ'}
      },
      {
        path: 'right-search',
        component: RightSearchComponent,
        data: {title: 'ตรวจสอบสิทธิรายบุคคล/ลงทะเบียน'}
      },
      {
        path: 'right-search/idcard',
        component: RightSearchByIdCardComponent,
        data: {title: 'ตรวจสอบสิทธิด้วยบัตรประจำตัวประชาชน (Smart Card)'},
      },
      {
        path: 'right-search/thaid',
        component: RightSearchByThaidComponent,
        data: {title: 'ตรวจสอบสิทธิด้วย ThaID'},
      },
      {
        path: 'right-search/personal-id',
        component: RightSearchByPersonalIdComponent,
        data: {title: 'ตรวจสอบสิทธิด้วยเลขประจำตัวประชาชน'},
      },
      {
        path: 'right-search/name',
        component: RightSearchByNameComponent,
        data: {title: 'ตรวจสอบสิทธิด้วยชื่อ-นามสกุล'},
        children: [
          {
            path: '',
            component: RegisterFormsComponent
          }
        ]
      },
      {
        path: 'right-search/name/:personalId/detail',
        component: RightSearchByNameDetailComponent,
        data: {title: 'ตรวจสอบสิทธิด้วยชื่อ-นามสกุล'},
        children: [
          {
            path: '',
            component: RegisterFormsComponent
          }
        ]
      },
      {
        path: 'registration',
        loadChildren: () => import('./pages/secure/register/registration.module').then(m => m.RegistrationModule)
      },
      {
        path: 'group-register',
        loadChildren: () => import('./pages/secure/group-register/group-register.module').then(m => m.GroupRegisterModule)
      },
      {
        path: 'group-menu',
        loadChildren: () => import('./pages/secure/group-menu/group-menu.module').then(m => m.GroupMenuModule)
      },
      {
        path: 'check-group',
        loadChildren: () => import('./pages/secure/check-group/check-group.module').then(m => m.CheckGroupModule),
        canActivateChild: [roleGuard],
        data: {role: ['admin', 'nhso', 'chk_right', 'reg_chk_right', 'senior_regis', 'chk_right_other', 'regis_zone', 'staff_call_center', 'regis_call_center', 'reg_exch_other']}
      },
      {
        path: 'erm-register',
        component: ErmRegisterComponent
      },
      {
        path: 'history',
        component: HistoryComponent,
        children: [
          {
            path: 'uc',
            component: UcRegisterHistoryComponent,
            data: {title: 'ประวัติการลงทะเบียน UC'},
          }
        ]
      },
      {
        path: 'point',
        component: PointContainerComponent,
        children: [
          {
            path: 'current',
            component: CurrentPointComponent,
            data: {
              title: 'คำนวณเหมาจ่ายรายหัว (รอบปัจจุบัน)'
            }
          },
          {
            path: 'history',
            component: PointHistoryComponent,
            data: {
              title: 'ประวัติการคำนวณเหมาจ่ายรายหัว'
            }
          },
          {
            path: 'summary-report',
            component: PointSummaryReportComponent,
            data: {
              title: 'รายงานคำนวณเหมาจ่ายรายหัว'
            }
          },
          {
            path: 'excluded-hospitals',
            component: ExcludedHospitalsComponent,
            data: {
              title: 'ตรวจสอบหน่วยบริการที่ออกจากระบบ'
            }
          },
          {
            path: 'manage-email-point',
            component: ManageEmailPointComponent,
            data: {
              title: 'จัดการอีเมล Point'
            }
          }
        ]
      },
      {
        path: 'arbitrary/summary',
        component: SummaryComponent,
        data: {
          title: 'สรุปผลการดำเนินงานของเขต'
        }
      },
      {
        path: 'arbitrary/tasks',
        component: NewWorkComponent,
        data: {
          title: 'ติดตามสถานะการตรวจสอบ',
          type: <ArbitraryMode>"TASK"
        }
      },
      {
        path: 'arbitrary/new',
        component: NewWorkComponent,
        data: {
          title: 'งานใหม่',
          type: <ArbitraryMode>"NEW"
        }
      },
      {
        path: 'arbitrary/report',
        component: ArbitraryReportComponent,
        data: {
          title: 'ส่งรายงานผลการตรวจสอบ',
        }
      },
      {
        path: 'arbitrary/tasks-details/:id',
        component: TasksDetailsComponent,
        data: {
          title: 'บันทึกผล',
        },
        resolve: {
          srmHospitalArbitrary: TasksDetailsResolverService,
        }
      },
      {
        path: 'arbitrary/email',
        component: ManageEmailComponent,
        data: {
          title: 'จัดการอีเมล'
        }
      },
      {
        path: 'arbitrary/book',
        component: CreatedBookComponent,
        data: {
          title: 'จัดการหนังสือ'
        }
      },
      {
        path: 'digital-address',
        component: DigitalAddressComponent,
        data: {title: 'ตรวจสอบที่อยู่ (Digital Address)'}
      },
      {
        path: 'search-sss',
        component: RightSearchSssComponent,
        data: {title: 'ตรวจสอบข้อมูลหมดสิทธิประกันสังคมรายวัน'},
      },
      {
        path: 'change-health-insurance',
        component: ChangeHealthInsuranceComponent,
        data: {title: 'รายงานการเปลี่ยนแปลงสิทธิประกันสุขภาพ และสิทธิว่างกรณีอื่น'}
      },
      {
        path: 'deceased-eligible-service',
        component: DeceasedEligibleServiceComponent,
        data: {title: 'รายงานผู้มีสิทธิที่เสียชีวิตที่ลงทะเบียนในเครือข่ายหน่วยบริการ'}
      },
      {
        path: 'revoked',
        component: RevokedComponent,
        data: {title: 'ปลดสิทธิกองทุนอื่น'}
      },
      {
        path: 'revoked/idcard',
        component: RightSearchByIdCardComponent,
        data: {title: 'ปลดสิทธิด้วยบัตรประจำตัวประชาชน (Smart Card)'},
      },
      {
        path: 'revoked/personal-id',
        component: RightSearchByPersonalIdComponent,
        data: {title: 'ปลดสิทธิด้วยเลขประจำตัวประชาชน'},
      },
      {
        path: 'revoked',
        loadChildren: () => import('./pages/secure/revoked/revoked.module').then(m => m.RevokedModule)
      },
      {
        path: 'ucep',
        component: UcepComponent,
        data: {title: 'ลงทะเบียนแบบกลุ่ม UCEP'}
      },
      {
        path: 'uc-advance',
        component: UcAdvanceComponent,
        data: {
          title: 'ลงทะเบียนแบบกลุ่มสิทธิ UC ล่วงหน้า'
        }
      },
      {
        path: 'uc-advance/registration',
        component: UcAdvanceRegisterComponent,
        data: {
          title: 'ลงทะเบียนแบบกลุ่มสิทธิ UC ล่วงหน้า'
        }
      },
      {
        path: 'uc-advance/history',
        component: UcAdvanceHistoryComponent,
        data: {
          title: 'ค้นหาประวัติการลงทะเบียนแบบกลุ่มสิทธิ UC ล่วงหน้า'
        }
      },
      {
        path: 'transfer',
        loadChildren: () => import('./pages/secure/transfer/transfer.module').then(m => m.TransferModule)
      },
      {
        path: 'right-history',
        component: RightHistoryComponent,
        data: {
          title: 'ตรวจสอบหลักฐานหลังการเกิดสิทธิ'
        }
      },
      {
        path: 'right-history/detail/:id',
        component: RightHistoryDetailComponent,
        resolve: {
          ermRegMain: ermRegMainConsiderServiceResolver
        },
        data: {
          title: 'รายละเอียดหลักฐานหลังการเกิดสิทธิ'
        }
      },
      {
        path: 'settings',
        loadChildren: () => import('./pages/secure/settigns/settings.module').then(m => m.SettingsModule)
      },
      // {
      //   path: 'modify-right',
      //   component: ModifyRightComponent,
      //   data: {
      //     title: 'แก้ไขสิทธิรักษาพยาบาล'
      //   }
      // }
    ]
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: '403',
    component: P403Component,
  },
  {
    path: '**',
    component: P404Component,
  },
];
